
import Popup from 'vux/src/components/popup/index.vue'

import HeadBar from '../HeadBar/HeadBar';
import CouponItem from './CouponItem';
import BindNewCoupon from './BindNewCoupon';
import {OrderProxy} from '@/http/RequestProxy.class';

const orderProxy = new OrderProxy();

export default {
name: 'coupon',
components: {
Popup,
HeadBar,
CouponItem,
BindNewCoupon,
},
props: {
value: {
type: Boolean,
default: false,
},
},
data(){
return {
isShowBindCoupon: false,  // 显示绑定优惠券页面
canUseList: [],           // 可使用的优惠券数据
noUseList: [],            // 不可用优惠券数据
selectedCoupon: {},       // 已选择的优惠券
unUseCoupon: false,       // 使用优惠券
};
},
computed: {
isShowCoupon: {
get(){
return this.value;
},
set(val){
this.$emit('input', val);
},
}
},
created(){
this.getCouponData();
},
methods: {
onBack(){
this.onHideCoupon();
},

/** 隐藏优惠券列表 */
onHideCoupon(){
this.$emit('input', false);
this.$emit('on-return-coupon', this.selectedCoupon);
},

/** 获取优惠券列表数据 */
getCouponData(){
orderProxy.getCouponData()
.then(resp => {
if(resp){
this.canUseList = resp.data.coupon_list;
this.noUseList = resp.data.coupon_no;
this.$emit('on-coupon-count', resp.data.coupon_list.length);
}
});
},

/** 获取新绑定的优惠券 */
onGetBindCoupon(couponData){

if(+couponData.status_type === 3){
this.selectedCoupon = couponData;
this.unUseCoupon = false;
this.canUseList.unshift(couponData);
this.onHideCoupon();
}else{
this.noUseList.unshift(couponData);
}
},

/** 选择优惠券 */
onSelectCoupon(curIdx){
if(this.selectedCoupon.serial_num === this.canUseList[curIdx].serial_num){
this.selectedCoupon = {};
}else{
this.selectedCoupon = this.canUseList[curIdx];
}
this.unUseCoupon = false;
this.onHideCoupon();
},

/** 不使用优惠券 */
onUnUseCoupon(){
this.unUseCoupon = !this.unUseCoupon;
if(this.unUseCoupon){
this.selectedCoupon = {};
}
this.onHideCoupon();
},
},
}



// WEBPACK FOOTER //
// ./src/components/Coupon/Coupon.vue